import VodService from '@/services/VodService'

const state = {
    show: {},
}

const actions = {
    async fetch({ commit }, { key, uvid, cc, lang }) {
        const vodService = new VodService()

        return new Promise((resolve, reject) => {
            vodService.get({ uvid, cc, lang, key })
                .then((response) => {
                    commit('SET_SHOW', response.response.show)
                    resolve()
                })
                .catch((err) => reject(err))
        })
    },
}

const mutations = {
    SET_SHOW(state, show) {
        state.show = show
    },
}

const getters = {
    get(state) {
        return state.show
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
